import React, { useContext } from 'react';
import { Text } from '../../components/typography';
import { ThemeContext } from '../../theming';

import { ProgressBar } from "react-bootstrap";
import Paso1 from "../../assets/images/progress/invoice-yellow.png"
import Resumen from "../../assets/images/progress/ccard-yellow.png"
import Finalizado from "../../assets/images/progress/payed-yellow.png"
import useWindowDimensions from '../../helpers/useWindowDimensions';

function Progress({ progress }) {
  const app = useContext(ThemeContext);
  const { width } = useWindowDimensions();

  const { body14, body32, body12, body28 } = app.theme.font;

  return <div className={"mt-3"}>
    <div className='d-flex justify-content-around'>
      <div className='d-flex flex-column justify-content-between align-items-center'>
        <img src={Paso1}
          style={{ width: width >= 701 ? "70px" : "55px", marginBottom: "10px" }}
          alt="" />
        {width >= 701 ? <Text type="primary" size={body14} bold={true} style={{ fontWeight: 600 }}>
          SELECCIONAR BOLETAS
        </Text> : <></>}
      </div>
      <div className='d-flex flex-column justify-content-between align-items-center'>
        <img src={Resumen}
          style={{ width: width >= 701 ? "70px" : "55px" }}
          alt="" />
        {width >= 701 ? <Text type="primary" size={body14} bold={true} style={{ fontWeight: progress >= 66 ? 600 : "" }}>
          PAGAR
        </Text> : <></>}
      </div>
      <div className='d-flex flex-column justify-content-between align-items-center'>
        <img src={Finalizado}
          style={{ width: width >= 701 ? "70px" : "55px" }}
          alt="" />
        {width >= 701 ? <Text type="primary" size={body14} bold={true} style={{ fontWeight: progress == 100 ? 600 : "" }}>
          PAGO FINALIZADO
        </Text> : <></>}
      </div>
    </div>
    <ProgressBar animated variant="warning" now={progress} />

  </div>;
}

export default Progress;
